import React, { useLayoutEffect } from "react"
import PropTypes from "prop-types";
import Immutable from "immutable";
import { connect } from "react-redux";
import { DEFAULT_PAGE_SIZE } from "../../../../config/constants";
import ModuleList from "../../../layout/ModuleList";
import { ENDPOINT_PATH, NEW_ENDPOINT_PATH } from "../../../../config/paths";
import { clearEndpoints, getEndpoints } from "../../../../actions/security";
import { breadcrumbsPropTypes } from "../../../common/resource/proptypes/CommonPropTypes";
import { ENDPOINT_COLUMNS } from "../../../../config/columns";

export const Endpoints = (
    {
  breadcrumbs,
  endpoints,
  loading,
  dispatchGetEndpoints,
  dispatchClearEndpoints,
}
) => {
    useLayoutEffect(()=>()=>dispatchClearEndpoints(), []);

    const data = endpoints.get('content') || [];
    const pages = endpoints.get('totalPages') || null;
    const defaultPageSize = endpoints.get('size') || DEFAULT_PAGE_SIZE;

    return (
    <ModuleList
        title="Puntos de Acceso"
        breadcrumbs={breadcrumbs}
        buttonPath={NEW_ENDPOINT_PATH}
        tableStructure={{
        columns: ENDPOINT_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetEndpoints,
        modelPath: ENDPOINT_PATH,
        loading,
        navigateToModelOnRowClick: true,
        }}
    />
    ); 
}

const mapDispatchToProps = {
  dispatchGetEndpoints: getEndpoints,
  dispatchClearEndpoints: clearEndpoints,
};

const mapStateToProps = ({ SecurityUnit }) => ({
  breadcrumbs: [
    ...SecurityUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Puntos de Acceso',
      href: ENDPOINT_PATH,
    },
  ],
  endpoints: SecurityUnit.Endpoint.getIn(['all', 'content']),
  loading: SecurityUnit.Endpoint.getIn(['all', 'loading']),
});

Endpoints.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  endpoints: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetEndpoints: PropTypes.func.isRequired,
  dispatchClearEndpoints: PropTypes.func.isRequired,
};

Endpoints.defaultProps = {
  endpoints: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Endpoints);